import { useCustomMutation } from "api/useCustomMutation";
import { useCustomQuery } from "api/useCustomQuery";
import { JANZU_URL } from "config/config";
import { UserProfile } from "types/users";

import { BaseQueryOptions, CachePolicy } from "../types";

// Terms of service fields interface
export interface TermsOfServiceFields {
  accepted_terms_of_service?: string;
  name?: string;
  company?: string;
}

export type LogoutResponse = {
  logged_out: boolean;
  // Present for Axon SSO: browser must navigate here to end the shared IdP session.
  idp_logout_url?: string;
};

// Hook for user logout (GET request)
export const useLogout = (
  options: BaseQueryOptions<LogoutResponse> = {}
) => useCustomQuery<LogoutResponse>(
  ["logout"],
  `${JANZU_URL}authz/logout`,
  {
    cachePolicy: CachePolicy.NO_CACHE,
    enabled: false, // Don't auto-fetch, only when manually called
    ...options,
  }
);

// Hook for accepting terms of service (PATCH request)
export const useAcceptTerms = (userId: string) => useCustomMutation<UserProfile, TermsOfServiceFields>(
  `${JANZU_URL}device-api/profile/${userId}`,
  "PATCH",
  {
    cachePolicy: CachePolicy.NO_CACHE,
  }
);